<p-panel header="{{ 'information_pages' | translate }}">

    <div class="ui-g" *ngFor="let page of informationPages">
        <div class="ui-g-9">
            <span>{{ page.desc | translate }}</span>
        </div>
        <div (click)="onEditInformationPage(page.id, 'pl', page.desc)" class="ui-g-1 link">PL</div>
        <div (click)="onEditInformationPage(page.id, 'en', page.desc)" class="ui-g-1 link">EN</div>   
        <div (click)="onEditInformationPage(page.id, 'de', page.desc)" class="ui-g-1 link">DE</div>
    </div>

</p-panel>
